// RTK Query slice for staff (personeel) management
import { createApi } from "@reduxjs/toolkit/query/react";
import { dynamicBaseQuery } from "./baseQuery";

export const personeelApi = createApi({
  reducerPath: "personeelApi",
  baseQuery: dynamicBaseQuery,
  refetchOnFocus: false,
  refetchOnReconnect: false,
  keepUnusedDataFor: 300, // Cache for 5 minutes
  tagTypes: ["Personeel"],
  endpoints: (builder) => ({
    /** Get all staff members */
    getPersoneel: builder.query({
      query: () => ({
        url: "api/personeel",
        method: "GET",
        headers: { "Cache-Control": "no-cache" },
      }),
      transformResponse: (response) => {
        return Array.isArray(response) ? response : [];
      },
      providesTags: ["Personeel"],
    }),

    /** Create new staff member */
    createPersoneel: builder.mutation({
      query: (body) => ({
        url: "api/personeel",
        method: "POST",
        body,
      }),
      invalidatesTags: ["Personeel"],
    }),

    /** Update staff member */
    updatePersoneel: builder.mutation({
      query: ({ id, ...body }) => ({
        url: `api/personeel/${id}`,
        method: "PATCH",
        body,
      }),
      invalidatesTags: ["Personeel"],
    }),

    /** Delete staff member */
    deletePersoneel: builder.mutation({
      query: (id) => ({
        url: `api/personeel/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Personeel"],
    }),
  }),
});

export const {
  useGetPersoneelQuery,
  useCreatePersoneelMutation,
  useUpdatePersoneelMutation,
  useDeletePersoneelMutation,
} = personeelApi;
